// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EHog","col":"styles_col__1f1VE"};